
import { defineComponent, PropType } from "vue";
import { Handle } from "@braks/vue-flow";
import FlowNodeWrapper from "@/components/bot/FlowNodeWrapper.vue";
import { IFlowBlockProps } from "./FlowNodeBlock.vue";

export default defineComponent({
  name: "FlowNodeOutlet",
  components: {
    Handle,
    FlowNodeWrapper,
  },
  props: {
    data: {
      type: Object as PropType<IFlowBlockProps>,
      required: true,
      default: () => {
        return {};
      },
    },
  },
});
